import type { IconSvgObject } from './types';

const ArrowDownFromLineIcon: IconSvgObject = [
  ["path", { d: "M12 20V8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17 15C17 15 13.3176 20 12 20C10.6824 20 7 15 7 15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M17 4H7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ArrowDownFromLineIcon;
